<template>
<div id="BuildingInfos">

    <div class="headLine">产业空间信息（存量商务楼宇）</div>
    <div v-if="auditRecord" class="backLine">退回原因：{{auditRecord}}</div>
    <div class="navLine">
        <div @click="navChange(1)" :class="['navItem',{ 'act' : navAct == 1 }]">楼宇信息</div>
        <div @click="navChange(2)" :class="['navItem',{ 'act' : navAct == 2 }]">
            <span>空间信息（{{floors}}）</span>
        </div>
        <div v-if="pgType == 1 && recordList" @click="navChange(3)" :class="['navItem',{ 'act' : navAct == 3 }]">审核历史</div>
    </div>

    <div class="pgContent">



       <div class="tabContent">
            <InfoText :hidden="navAct !== 1" />
            <FloorList @floorC="floorC" :hidden="navAct !== 2" />
            <RecordList  :hidden="navAct !== 3" />
       </div>

      <template v-if="pgType == 2">
        <div class="auditOpinion">
          <span class="iName">审核意见</span>
          <div class="iRadio">
            <el-radio-group v-model="status">
                <el-radio :label="1">通过</el-radio>
                <el-radio :label="2">退回</el-radio>
            </el-radio-group>
          </div>
          <div class="backInput" v-if="status==2">
              <el-form :model="params" :show-message="false" :rules="rules" ref="ruleForm">
                  <el-form-item prop="back">
                      <el-input v-model="params.back"  size="small" placeholder="请输入回退意见" />
                  </el-form-item>
              </el-form>
          </div>
       </div>
                
       </template>
       
    
    </div>

    <div class="btnLine">
          <template v-if="pgType == 2">
            <el-button @click="confirm()" type="primary" size="small">提交</el-button>
            <!-- <el-button @click="stateSet(6)" type="danger" size="small">退回</el-button> -->
              <!-- <template v-if="vType == 1">
                <el-button @click="stateSet(1)" type="primary" size="small">通过</el-button>
                <el-button @click="stateSet(6)" type="danger" size="small">退回</el-button>
              </template>
              <template v-if="vType == 2">
                <el-button @click="stateSet(2)" type="primary" size="small">通过</el-button>
                <el-button @click="stateSet(3)" type="danger" size="small">退回</el-button>
              </template> -->
          </template>
          <el-button @click="pageBack" size="small">返回</el-button>
    </div>

</div>
</template>
<script>
import { upState } from '@/api/industryInfos';
import InfoText from './components/infoText';
import FloorList from './components/floorList';
import RecordList from './components/recordList';
import { getBuildingInfos } from '@/api/industryInfos';
var backCheck = (rule, value, callback) => {
    if(!value){
       return callback(new Error('请填写回退意见'));
    }else{
       callback();
    }
}
export default{
  components:{
    InfoText,
    FloorList,
    RecordList
  },
  data(){
    return{
        industrialSpaceId:'',
        pgType:1,   //  1 查看 2 审核
        vType:0,
        navAct:1,
        floors:0,
        recoredList:false,
        status:0,
        auditRecord:'',
        params:{
          back:'',
        },
        rules:{
            back:[{validator: backCheck, trigger: 'blur'}],
        }
    }
  },
  methods:{
    navChange(inx){
      this.navAct = inx;
    },
    pageBack(){
      this.$router.go(-1);
    },
    confirm(){
      var state=0;
      if(this.vType == 1){
          if(this.status==1){
            state=1;
          }
          if(this.status==2){
            state=6;
          }
      }
      if(this.vType == 2){
        if(this.status==1){
            state=2;
          }
          if(this.status==2){
            state=3;
          }
      }
      if(state==0){
        this.$message.error('请选择审核状态');
        return;
      }
      if(this.status==2){
          this.$refs.ruleForm.validate((valid) => {
            if(valid){
              upState({
                ids:[this.industrialSpaceId],
                auditRecord:this.params.back,
                status:state
              }).then(res => {
                  this.$message.success('操作成功！');
                  this.$router.go(-1);
              })
            }
              
          });
      }else{
        upState({
          ids:[this.industrialSpaceId],
          status:state
        }).then(res => {
            this.$message.success('操作成功！');
            this.$router.go(-1);
        })
      }
      
    },
    floorC(e){
      this.floors = e;
    }
  },

  created(){
     let querys = this.$route.query;
     this.pgType = querys.type || 1;
     this.vType = querys.vtype || 0;
     this.industrialSpaceId = querys.id;
     getBuildingInfos({id:querys.id}).then(res => {
           this.auditRecord = res.industrialSpace.auditRecord;
       });
     this.recordList = querys.from;
  }
}
</script>
<style lang='scss' scoped>

#BuildingInfos{
    font-size: 15px;
    .headLine{
        padding: 0 20px;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #EBEEF5;
    }
    .backLine{
        padding: 0 20px;
        height: 60px;
        color: red;
        line-height: 60px;
        border-bottom: 1px solid #EBEEF5;
    }
    .navLine{
       padding-left: 20px;
       border-bottom: 1px solid #EBEEF5;
       .navItem{
           height: 54px;
           font-size: 14px;
           margin: 0 30px;
           display: inline-block;
           line-height: 54px;
           border-bottom: 2px solid white;
           cursor: pointer;
           &.act{
              color: #409EFF;
              border-color: #409EFF;
           }
       }
    }

    .pgContent{
        margin: 20px;
        position: relative;
    }
    .auditOpinion{
      min-width: 1000px;
      padding-top: 20px;
      border-top: 1px solid #EBEEF5;
      width: 100%;
      margin-top: 20px;
      margin-bottom: 20px;
      display:flex;
      .iName{
        width: 120px;
        margin-bottom: 10px;
      }
      .iRadio{
        padding-top: 5px;
      }
      .backInput{
        margin-top: -5px;
        margin-left: 40px;
      }
    }
    .el-input {
      width: 450px;
    }
    .btnLine{
        margin-top: 20px;
        padding-left: 20px;
        .el-button{
            width: 90px;
        }
    }

    .imgs{
        font-size: 14px;
        margin: 20px 10px;
        .imgTtl{
            margin-bottom: 10px;
        }
    }
}

</style>



// WEBPACK FOOTER //
// index.vue?0653ba16